/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./playablePreviewer.vue?vue&type=template&id=54f48e09&scoped=true&"
import script from "./playablePreviewer.vue?vue&type=script&lang=js&"
export * from "./playablePreviewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f48e09",
  null
  
)

export default component.exports